import { Component, inject, OnInit } from '@angular/core'
import {
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms'
import { RouterModule } from '@angular/router'
import { of } from 'rxjs'
import { tap, catchError } from 'rxjs/operators'

import {
  BaseDialogComponent,
  ErrorComponent,
  ReusableDialogComponent,
  TypographyComponent,
  RadioButtonComponent,
  ButtonComponent,
  TextAreaComponent,
} from '@hyperkit'

import { FeedbackType, SupportService } from '../../../services/support.service'

@Component({
  standalone: true,
  selector: 'cyborg-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss'],
  imports: [
    ReactiveFormsModule,
    RouterModule,
    ReusableDialogComponent,
    TypographyComponent,
    RadioButtonComponent,
    ButtonComponent,
    TextAreaComponent,
    ErrorComponent,
  ],
})
export class FeedbackModalComponent
  extends BaseDialogComponent<{ uuid: string }, void>
  implements OnInit
{
  private supportService = inject(SupportService)
  public error: string
  public submitted = false
  public feedbackForm: FormGroup
  public selectedType: FeedbackType = 'Support'
  public feedbackExplanations: Record<FeedbackType, string> = {
    Support:
      'Related to issues with deploying the hunt package content queries',
    Tuning:
      'Related to issues with a large number of false positives/negatives',
    Syntax: 'Related to issues with the output of the content queries',
    Request:
      'Related to requesting additional content, context or documentation',
  }

  public feedbackTypes: Array<FeedbackType> = Object.keys(
    this.feedbackExplanations,
  ) as Array<FeedbackType>

  public ngOnInit(): void {
    this.feedbackForm = new FormGroup({
      message: new FormControl('', [Validators.required]),
      feedbackType: new FormControl(this.selectedType, [Validators.required]),
    })
  }

  public onSendFeedBack(): void {
    this.supportService
      .sendFeedbackEmail({
        type: this.feedbackForm.value.feedbackType,
        UUID: this.data.uuid,
        message: this.feedbackForm.value.message,
      })
      .pipe(
        tap(() => {
          this.submitted = true
          this.feedbackForm.patchValue({
            subject: '',
            message: '',
          })
        }),
        catchError((err) => {
          console.error(err)
          this.error = 'There was an issue sending your feedback.'
          return of(null)
        }),
      )
      .subscribe()
  }

  return(): void {
    this.dialogRef.close()
  }

  protected initializeOptions(): void {
    this.options = { headerText: 'Send Us Feedback' }
  }
}
